<template>
  <div class="app-step-two-tabs-targeting">
    <div class="app-step-two-tabs__wrapper">
      <div class="app-step-two-tabs-targeting__body">
        <div
          class="app-step-two-tabs-targeting__col app-step-two-tabs-targeting-info"
        >
          <div class="app-step-two-tabs-targeting__line"></div>
          <h5 class="app-step-two-tabs-targeting-info__title">
            Targeting - Where to Send Your Press Release
          </h5>
          <p class="app-step-two-tabs-targeting-info__descr">
            In addition to our standard U.S. national distribution list, the
            {{ packageItem?.name }} distribution package includes the targeting
            of your press release to
            {{ packageItem?.maxFreeIndustryTargets }}
            industry
            {{ pluralize(packageItem?.maxFreeIndustryTargets, 'target') }}
          </p>
          <p
            v-if="freeInfluencers"
            class="app-step-two-tabs-targeting-info__descr"
          >
            Influencers included in {{ packageName }}: {{ freeInfluencers }}.
            Additional Influencers are available at
            {{ additionalInfluencersPrice }} per additional Influencer.
          </p>
          <a
            target="_blank"
            href="https://www.ereleases.com/lists/"
            class="app-step-two-tabs-targeting-info__link"
            >Click to view a representative list of contacted media</a
          >
        </div>
        <div
          class="app-step-two-tabs-targeting__col app-step-two-tabs-targeting-tabs"
        >
          <div class="tabs">
            <ul class="targeting-tabs">
              <li
                v-for="tab in tabs"
                :key="tab.id"
                :class="[
                  'tab-button targeting-tab',
                  { 'is-active': currentTabId === tab.id },
                ]"
                @click="currentTabId = tab.id"
              >
                <a href="#" @click.prevent> {{ tab.name }} </a>
              </li>
            </ul>
          </div>
          <div class="app-step-two-tabs-targeting-tabs-content">
            <keep-alive>
              <component :is="tabToRender?.component" class="tab"></component>
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <navigation-buttons
      :disabled-outer-condition="isLoading"
      :loading="isLoading"
      @onPreviousButtonClick="handlePreviousClick"
      @onNextButtonClick="handleNextClick"
    ></navigation-buttons>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { pluralize } from '@core/utils/helpers'

import IndustryTargets from './industry-targets/index.vue'
import LocalTargets from './local-targets/index.vue'
import InfuencersList from './influencer-lists/index.vue'
import InternationalTargets from './international-targets/index.vue'
import NavigationButtons from '@modules/app-steps/step-two/navigation-buttons/index.vue'

import { useNavigationButtons } from '@modules/app-steps/step-two/navigation-buttons'
import { useOrder } from '@core/composables/order/useOrder'
import { useTabsStore } from '@/stores/tabs'
import { formatPrice } from '@core/utils/price'

const { navigate } = useNavigationButtons()
const { order, useUpdateOrder } = useOrder()
const { isLoading, updateOrder } = useUpdateOrder()
const { getFrontendTabBuilder } = useTabsStore()

const tabs = [
  { id: 1, component: IndustryTargets, name: 'Add Industry' },
  { id: 2, component: LocalTargets, name: 'Add Local' },
  { id: 3, component: InfuencersList, name: 'Add Influencer Lists' },
  { id: 4, component: InternationalTargets, name: 'Add International' },
]
const currentTabId = ref(1)

const tabToRender = computed(() =>
  tabs.find((tab) => tab.id === currentTabId.value)
)

const packageItem = computed(() => order?.value?.packagePrice?.package)

const packageName = computed(() => order?.value?.packagePrice?.package?.name)
const freeInfluencers = computed(
  () => order?.value?.packagePrice?.package?.influencers
)
const additionalInfluencersPrice = computed(() =>
  formatPrice(order?.value?.packagePrice?.package?.influencersPrice)
)

const handlePreviousClick = () =>
  updateOrder({ ...getFrontendTabBuilder() }, () => navigate())

const handleNextClick = () =>
  updateOrder({ ...getFrontendTabBuilder(true) }, () => navigate(true))
</script>
